import { CommonModule } from '@angular/common'
import { Component, OnInit, WritableSignal, inject, signal } from '@angular/core'
import { Router, RouterOutlet, NavigationEnd } from '@angular/router'

import { filter } from 'rxjs';

import { Store } from '@ngrx/store'
import { NgxSpinnerModule } from 'ngx-spinner'
import { SplashScreenComponent } from './shared'
import { BannerNuevaVersionComponent } from '@app/shared/components/banner-nueva-version/banner-nueva-version.component'
import { AvisoProduccionComponent } from '@app/shared/components/aviso-produccion/aviso-produccion.component'
import * as fromRoot from './store'


import { environment } from '@src/environments/environment';
import { ClarityService } from '@app/services/general/clarity.service';
import { TawkToService } from '@app/services/general/tawk-to.service';

import { ServicioSesion } from '@app/services/sesion/sesion.service';
import { ThemingService } from '@app/services/general/theming.service';
import { SeoAnalyticsService } from '@app/services/seo-analytics.service';
import { SvgIconsService } from '@app/services/general/svg-icons.service';
//import * as fromMatches from './store/zarchived_matches'
//import * as fromPositionsTable from './store/zarchived_positions-table'
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
    NgxSpinnerModule,
    BannerNuevaVersionComponent,
    AvisoProduccionComponent,
  ],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  private _sesion = inject(ServicioSesion);
  private _theming = inject(ThemingService);
  private _seoAnalytics = inject(SeoAnalyticsService);
  private _svgIcons = inject(SvgIconsService);
  private clarityService = inject(ClarityService);
  private _tawkTo = inject(TawkToService);


  private _router = inject(Router);
  //private _store: Store<fromRoot.State>;

  public $showSplash: WritableSignal<boolean>;

  constructor() {
    //this._store = inject(Store);
    console.log('%c ENTORNO CARGADO:', 'background: #222; color: #bada55', environment);
    this._svgIcons.registrarTodos();
    this.$showSplash = signal(true);
  }

  ngOnInit(): void {
    this._seoAnalytics.init();

    /**
     * Se aplica tema de color según el rol usado en el sistema
     */
        // También sin rol (logout/sin sesión) para volver a los colores default del subdominio.
        this._sesion.rolActivo$.subscribe(() => {
          // Modo oscuro primero: aplicarTemaSegunPerfil() usa .modo-oscuro para los defaults de --color-bg/fondoMenu.
          this._theming.aplicarModoOscuro();
          this._theming.aplicarTemaSegunPerfil();
        });

        // Escucha cambios de RUTA para detectar si entró al Portal
        this._router.events.pipe(
          filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
          this._theming.aplicarModoOscuro();
          this._theming.aplicarTemaSegunPerfil();
        });

    setTimeout((): void => {
      this.$showSplash.set(false);




    }, 3000);
    this.clarityService.init();
    this._tawkTo.init();
  }
}
